// some utils
// @author CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @create 2020/08/28 00:12
/** noop function */
export const noop = (x) => x;
/**
 * 是否是空值 (null, undefined)
 */
export const isNullValue = (obj) => {
    return obj === null || obj === undefined;
};
export const isEmpty = (obj) => {
    return isNullValue(obj) || obj === '';
};
const numFmt = (n) => (n > 9 ? `${n}` : `0${n}`);
/**
 * 返回时间戳: HH:mm:ss.LLL
 */
export const timestamp = (d = new Date()) => {
    return `${numFmt(d.getHours())}:${numFmt(d.getMinutes())}:${numFmt(d.getSeconds())}.${d.getMilliseconds()}`;
};
/**
 * 睡眠一定时间
 * @param mill milliseconds，< 0 表示无限 sleep
 */
export const sleep = (mill) => {
    if (!mill)
        return Promise.resolve();
    return new Promise((resolve) => {
        // 如果 mill < 0，则表示一直 sleep
        if (mill > 0) {
            setTimeout(resolve, mill);
        }
    });
};
/**
 * 从一个 json 对象中解析剔除无用的属性
 */
export const keepProps = (obj, keys) => {
    return keys.reduce((prev, key) => {
        if (Reflect.has(obj, key)) {
            prev[key] = obj[key];
        }
        return prev;
    }, {});
};
/**
 * 将 JSON 转化为 formData
 */
export const json2FormData = (obj = {}) => {
    if (obj instanceof FormData) {
        return obj;
    }
    const fd = new FormData();
    for (const key in obj) {
        if (Reflect.has(obj, key)) {
            const value = obj[key];
            if (isNullValue(value))
                continue;
            if (value instanceof Blob) {
                fd.append(key, value);
            }
            else {
                const valueStr = typeof value === 'object' ? JSON.stringify(value) : value;
                fd.append(key, valueStr);
            }
        }
    }
    return fd;
};
